/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon24Regular = forwardRef('ScanBarcodeClassicIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.25 5.25a.75.75 0 0 0-1.5 0v13.5a.75.75 0 0 0 1.5 0V5.25Z" }),
        React.createElement("path", { d: "M7.5 4.5a.75.75 0 0 1 .75.75v11.186a.75.75 0 0 1-1.5 0V5.25a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M11.25 5.25a.75.75 0 0 0-1.5 0v11.186a.75.75 0 0 0 1.5 0V5.25Z" }),
        React.createElement("path", { d: "M13.5 4.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-1.5 0V5.25a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M17.25 5.25a.75.75 0 0 0-1.5 0v11.186a.75.75 0 0 0 1.5 0V5.25Z" }),
        React.createElement("path", { d: "M20.25 5.25a.75.75 0 0 0-1.5 0v13.5a.75.75 0 0 0 1.5 0V5.25Z" })));
});
